/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

export enum UserIntentType { join_group = 'join_group' }

export interface UserData {
  allow_backpack_email_communication: boolean;
  allow_thirdparty_email_communication: boolean;
  complimentary_pro_access_groups: string[];
  created_at: string;
  cuid: string;
  email: string;
  email_verified: boolean;
  has_complimentary_pro_access: boolean;
  id: number;
  intent?: {
    type: UserIntentType;
    join_group?: {
      group_id: number;
    };
  };
  intercom_ios_hash: string;
  intercom_web_hash: string;
  iso2_code: string;
  locale_id: number;
  mfa_enabled: number;
  mobile_number?: string;
  pending_email: string;
  profile_id: number;
  role: string;
  state: string;
  updated_at: string;

  country_code?: string;
  mfa_type?: string;
}

class UserModel {

  public data: UserData;

  public static hasGroupIntent(groupData) {
    return _.get(groupData, 'intent.type', null) === UserIntentType.join_group;
  }

  public static addJoinGroupIntent(userData, groupId) {
    return {
      ...userData,
      intent: {
        type: 'join_group',
        join_group: {
          group_id: groupId,
        },
      },
    };
  }

  constructor(data) {
    this.data = { ...data };
  }

  profileId() {
    return this.data.profile_id;
  }

  isMfaEnabled() {
    return this.data.mfa_enabled === 1;
  }

  clearMfa() {
    this.data.country_code = null;
    this.data.mobile_number = null;
    this.data.mfa_enabled = 0;
    this.data.mfa_type = null;
  }

  hasPendingEmail() {
    return !!this.data.pending_email;
  }

  getPendingEmail() {
    return this.data.pending_email;
  }

  getEmail() {
    return this.data.email;
  }

  setLocale(localeId) {
    this.data.locale_id = localeId;
  }

  hasJoinGroupIntent() {
    return _.get(this, 'data.intent.type', null) === UserIntentType.join_group;
  }

  intentToJoinGroupId() {
    return _.get(this, 'data.intent.join_group.group_id', null);
  }
}

export default UserModel;
